import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Music, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MusicSection = () => {
  const [thumbnails, setThumbnails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchThumbnails();
  }, []);

  const fetchThumbnails = async () => {
    try {
      const res = await axios.get(`${API}/music-thumbnails`);
      setThumbnails(res.data.slice(0, 4)); // Max 4
    } catch (error) {
      console.error('Error fetching music thumbnails:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="py-12">
        <div className="flex items-center justify-center">
          <Loader2 className="animate-spin text-[#E91E8C]" size={32} />
        </div>
      </div>
    );
  }

  if (thumbnails.length === 0) {
    return null; // Don't show section if no thumbnails
  }

  return (
    <section className="py-0" data-testid="music-section">
      <div>
        {/* Header - Badge style like Shows and Tienda */}
        <div className="flex items-center justify-center mb-10">
          <Link 
            to="/musica"
            className="section-title w-full text-center px-8 py-3 bg-black text-white text-2xl md:text-3xl uppercase tracking-wide hand-drawn-subtle hover:bg-[#E91E8C] transition-colors"
            style={{ borderWidth: '3px', borderColor: '#fff', borderStyle: 'solid' }}
            data-testid="view-music-page"
          >
            Música
          </Link>
        </div>

        {/* Thumbnails Grid - 4 columns on desktop, 2x2 on mobile */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {thumbnails.map((thumb) => (
            <a
              key={thumb.id}
              href={thumb.link_url || '/musica'}
              target="_blank"
              rel="noopener noreferrer"
              className="group block bg-black hand-drawn-subtle overflow-hidden transition-transform hover:scale-[1.02]"
              style={{ borderWidth: '3px', borderColor: '#fff', borderStyle: 'solid' }}
              data-testid={`music-thumb-${thumb.id}`}
            >
              <div className="relative aspect-square overflow-hidden">
                {thumb.image_url ? (
                  <img
                    src={thumb.image_url}
                    alt={thumb.title || 'Álbum'}
                    className="w-full h-full object-cover transition-transform group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-800">
                    <Music size={48} className="text-white/20" />
                  </div>
                )}
                
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <Music size={32} className="text-white" />
                </div>
              </div>
              
              {/* Title if provided */}
              {thumb.title && (
                <div className="p-3">
                  <h3 className="text-white font-bold text-sm text-center line-clamp-1 group-hover:text-[#E91E8C] transition-colors">
                    {thumb.title}
                  </h3>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
